import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询配载池
export function queryLoadPool(data) {
  return request({
    url: URL.booking.airExport.queryLoadPool,
    method: 'post',
    data
  })
}

// 保存拼装计划
export function saveAssemblyPlan(data) {
  return request({
    url: URL.booking.airExport.saveAssemblyPlan,
    method: 'post',
    data
  })
}

// 保存拼装计划-成本
export function saveAssemblyPlanCost(data) {
  return request({
    url: URL.booking.airExport.saveAssemblyPlanCost,
    method: 'post',
    data
  })
}

// 拼装处理
export function assemblyHandle(data) {
  return request({
    url: URL.booking.airExport.assemblyHandle,
    method: 'post',
    data
  })
}

// 拼装处理
export function mergeAssemblyPlan(data) {
  return request({
    url: URL.booking.airExport.mergeAssemblyPlan,
    method: 'post',
    data
  })
}

// 编辑拼装计划状态
export function editAssemblyPlanStatus(data) {
  return request({
    url: URL.booking.airExport.editAssemblyPlanStatus,
    method: 'post',
    data
  })
}

// 查询拼装计划
export function queryAssemblyPlan(data) {
  return request({
    url: URL.booking.airExport.queryAssemblyPlan,
    method: 'post',
    data
  })
}

// 查找唯一的拼装计划
export function findAssemblyPlan(data) {
  return request({
    url: URL.booking.airExport.findAssemblyPlan,
    method: 'post',
    data
  })
}

// 查询拼装计划详情
export function queryAssemblyPlanDetail(data) {
  return request({
    url: URL.booking.airExport.queryAssemblyPlanDetail,
    method: 'post',
    data
  })
}
